<template>
  <v-dialog v-model="dialog" :persistent="savable" width="600px">
    <v-card>
      <v-card-title class="mx-3">
        {{
          $t(
            isNew
              ? "CRUD.newInfo"
              : savable
              ? "CRUD.editInfo"
              : "CRUD.viewInfo",
            [$t("DishTemplate.ObjectName")]
          )
        }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>
            {{ $t("CRUD.backToList", [$t("DishTemplate.ObjectName")]) }}
          </span>
        </v-tooltip>
      </v-card-title>
      <v-card-text>
        <v-container>
          <ValidationObserver ref="observer">
            <v-row>
              <v-col cols="12">
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('DishTemplate.Fields.template_name')"
                  rules="required"
                >
                  <v-text-field
                    required
                    :readonly="isView"
                    v-model="dish_template.template_name"
                    :error-messages="
                      $resparse
                        .getErrorMsgs(serverErrors, 'template_name')
                        .concat(errors)
                    "
                  >
                    <template v-slot:label>
                      {{ $t("DishTemplate.Fields.template_name") }}
                      <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </ValidationObserver>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="accent" @click="save()">{{ $t("CRUD.save") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapState } from "vuex";
import {
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import DishTemplates from "@/api/dish_templates";

setInteractionMode("eager");

export default {
  name: "DishTemplateDetail",

  props: ["value", "mode"],

  components: {
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new" || this.mode == "clone";
    },
    isNew() {
      return this.mode == "new" || this.mode == "clone";
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    dish_template: {},
    serverErrors: [],
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          // 重设数据时要重置校验报错
          this.serverErrors = [];
          if (this.$refs && this.$refs.observer) this.$refs.observer.reset();
          this.dish_template = JSON.parse(JSON.stringify(this.value)); // 生成新对象
          if (this.mode == "clone") {
            this.dish_template.duplicate_id = this.dish_template.id;
            this.dish_template.id = 0;
          }
        }
      },
    },
    mode: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = !!this.mode;
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.$emit("mode", null);
          this.$emit("input", null);
          this.$store.dispatch("fullscreenLoadingStop");
        }
      },
    },
  },

  methods: {
    save() {
      this.$store.dispatch("fullscreenLoading");
      // 先清理后台返回的错误
      this.serverErrors = [];
      // 做前端校验
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            //校验成功再提交
            DishTemplates.save(this.dish_template.id, this.dish_template)
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$emit("save", this.dish_template);
                    this.$emit("mode", null);
                    this.$emit("input", null);
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.serverErrors = response.data.error.data;
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
  },
};
</script>